"use client"
import { useIsDesktop } from "@/hooks/app/useIsDesktop"
import { globalActions } from "@/lib/redux/features/global/reduce"
import { useAppDispatch, useAppSelector } from "@/lib/redux/hooks"
import { Col, Drawer, Row } from "antd"

const NavigationButton = () => {
  const shownMobileNav = useAppSelector(state => state.global.shownMobileNav)
  const dispatch = useAppDispatch()
  const isDesktop = useIsDesktop()

  if (isDesktop) {
    return <></>
  }

  return (
    <Col className="layout__mobilenav--button" >
      <Row justify='center' align='middle' className="layout__mobilenav--button-box">
        <input onChange={() => dispatch(globalActions.toggleMobileNav())} checked={shownMobileNav} type="checkbox" className="layout__mobilenav--button-checkbox" id="layout__mobilenav--button-checkbox" />
        <label className="layout__mobilenav--button-content" htmlFor="layout__mobilenav--button-checkbox">
          <span className="layout__mobilenav--button-icon">&nbsp;</span>
        </label>
      </Row>
    </Col>
  )
}

export default NavigationButton